import { DateTime } from "luxon";

export function sortStrings(a = '', b = '') {
    const lower = {
        a: a.toLowerCase(),
        b: b.toLowerCase()
    };

    if (lower.a < lower.b)
        return -1;
    if (lower.a > lower.b)
        return 1;
    return 0;
}

export function sortDates(a = '', b = '') {
    const dates = {
        a: DateTime.fromISO(a),
        b: DateTime.fromISO(b)
    };

    if (dates.a < dates.b)
        return -1;
    if (dates.a > dates.b)
        return 1;
    return 0;
}

export default {
    sortStrings,
    sortDates,
};